import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export const usePortScanner = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [formData, setFormData] = useState({
    ip: "",
    portType: "",
  });
  const [responseFromServer, setResponseFromServer] = useState(null);
  const form = useRef(null);

  const { t } = useTranslation();

  return {
    showLoader,
    setShowLoader,
    formData,
    setFormData,
    responseFromServer,
    setResponseFromServer,
    form,
    t,
  };
};
